import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import QuestionCard from './QuestionCard';

const ShootingPlaceTypeStep = ({ formData, onUpdate }) => {
  const [selectedPlace, setSelectedPlace] = useState(formData?.shootingPlaceType || '');

  const allShootingPlaces = [
    {
      value: 'indoor',
      label: 'داخلي',
      description: 'التصوير في مكان داخلي ',
      icon: 'Home'
    },
    {
      value: 'outdoor',
      label: 'خارجي',
      description: 'التصوير في مكان خارجي ',
      icon: 'MapPin'
    },
    {
      value: 'indoor_outdoor',
      label: 'داخلي وخارجي',
      description: 'التصوير في مكان داخلي وخارجي ',
      icon: 'Layers'
    },
    {
      value: 'photographer_studio',
      label: 'في استديو المصور',
      description: 'التصوير في استديو المصور',
      icon: 'Camera'
    }
  ];

  // TODO: إعادة تفعيل خيار الاستديو لاحقاً (مخفي مؤقتاً)
  const shootingPlaces = allShootingPlaces.filter(place => place.value !== 'photographer_studio');

  const handlePlaceChange = (value, label) => {
    setSelectedPlace(value);
    onUpdate({ 
      shootingPlaceType: value,
      shootingPlaceTypeLabel: label
    });
  };

  return (
    <QuestionCard
      icon="MapPin"
      title="أين سيتم التصوير؟"
      description="اختر نوع مكان التصوير لتحديد الموقع المناسب"
    >
      <div className="grid grid-cols-1 gap-3">
        {shootingPlaces?.map((place) => (
          <button
            key={place?.value}
            onClick={() => handlePlaceChange(place?.value, place?.label)}
            className={`p-5 rounded-xl border-2 text-right transition-all hover:border-primary hover:bg-primary/5 ${
              formData?.shootingPlaceType === place?.value
                ? 'border-primary bg-primary/10 shadow-sm'
                : 'border-border bg-background'
            }`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={place?.icon} size={20} className="text-primary" />
                  </div>
                  <div>
                    <div className="text-base font-semibold text-foreground">
                      {place?.label}
                    </div>
                    <div className="text-sm text-muted-foreground mt-1">
                      {place?.description}
                    </div>
                  </div>
                </div>
              </div>
              {formData?.shootingPlaceType === place?.value && (
                <Icon name="CheckCircle2" size={20} color="var(--color-primary)" className="flex-shrink-0" />
              )}
            </div>
          </button>
        ))}
      </div>
    </QuestionCard>
  );
};

export default ShootingPlaceTypeStep;
